import { inject, Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Address, Customer, DeliveryOptions, Festival, Package, Product } from '@shared';
import { BasketStateModel } from './basket.interfaces';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly http: HttpClient = inject(HttpClient);

  public fetchFestivalData(id: number): Observable<Festival> {
    return this.http.get<Festival>(
      `${environment.apiBaseUrl}spa/festivals/${id}/lodges-with-days`,
    );
  }

  public fetchFestivals(): Observable<Festival[]> {
    return this.http.get<Festival[]>(`${environment.apiBaseUrl}festivals`);
  }

  public submitBookingRequest(booking: BasketStateModel) {
    return this.http.post<void>(
      `${environment.apiBaseUrl}spa/reservation`,
      booking,
    );
  }
}
